<template>
  <div>
    <div class="search-div common-section-bg">
      <template v-if="isPropertyMode">
        <div class="shaixuan-item">
          <el-select v-model="filters.project" filterable clearable placeholder="项目（可搜索）" size="mini">
            <el-option v-for="item in projectSelectOptions" :key="item" :label="item" :value="item" />
          </el-select>
        </div>
        <div class="shaixuan-item">
          <el-input v-model="filters.plate" size="mini" clearable placeholder="车牌号" />
        </div>
        <div class="shaixuan-item">
          <el-input v-model="filters.owner" size="mini" clearable placeholder="业主姓名" />
        </div>
        <div class="shaixuan-item">
          <el-select v-model="filters.abnormal" filterable clearable placeholder="异常状态" size="mini">
            <el-option label="无异常" value="__none__" />
            <el-option label="有异常" value="__has__" />
            <el-option v-for="item in abnormalTypeOptions" :key="item" :label="item" :value="item" />
          </el-select>
        </div>
        <div class="shaixuan-item">
          <el-input v-model="filters.room_no" size="mini" clearable placeholder="房号" />
        </div>
        <div class="shaixuan-item">
          <el-input v-model="filters.parking_space" size="mini" clearable placeholder="车位号" />
        </div>
        <div class="shaixuan-item">
          <el-input v-model="filters.phone" size="mini" clearable placeholder="手机号" />
        </div>
        <div class="shaixuan-item">
          <el-input v-model="filters.remark" size="mini" clearable placeholder="备注" />
        </div>
      </template>
      <template v-else>
        <div class="shaixuan-item">
          <el-select v-model="filters.city" filterable clearable placeholder="城市（可搜索）" size="mini" @change="onCityChange">
            <el-option v-for="item in cityOptions" :key="item" :label="item" :value="item" />
          </el-select>
        </div>
        <div v-if="extendedFilters" class="shaixuan-item">
          <el-select v-model="filters.project" filterable clearable placeholder="项目（可搜索）" size="mini">
            <el-option v-for="item in projectSelectOptions" :key="item" :label="item" :value="item" />
          </el-select>
        </div>
        <div class="shaixuan-item">
          <el-input v-model="filters.plate" size="mini" clearable placeholder="车牌号" />
        </div>
        <div class="shaixuan-item">
          <el-input v-model="filters.owner" size="mini" clearable placeholder="业主姓名" />
        </div>
        <template v-if="extendedFilters">
          <div class="shaixuan-item">
            <el-input v-model="filters.id_card" size="mini" clearable placeholder="业主身份证号" />
          </div>
          <div class="shaixuan-item">
            <el-input v-model="filters.phone" size="mini" clearable placeholder="业主手机号" />
          </div>
          <div class="shaixuan-item">
            <el-select v-model="filters.in_garage" clearable placeholder="在库" size="mini">
              <el-option label="是" value="是" />
              <el-option label="否" value="否" />
            </el-select>
          </div>
          <div class="shaixuan-item">
            <el-select v-model="filters.vehicle_type" filterable clearable placeholder="类型" size="mini">
              <el-option v-for="item in vehicleTypeOptions" :key="item" :label="item" :value="item" />
            </el-select>
          </div>
          <div class="shaixuan-item">
            <el-select v-model="filters.abnormal" filterable clearable placeholder="异常" size="mini">
              <el-option label="无异常" value="__none__" />
              <el-option label="有异常" value="__has__" />
              <el-option v-for="item in abnormalTypeOptions" :key="item" :label="item" :value="item" />
            </el-select>
          </div>
          <div class="shaixuan-item">
            <el-input v-model="filters.parking_space" size="mini" clearable placeholder="车位" />
          </div>
          <div class="shaixuan-item">
            <el-input v-model="filters.remark" size="mini" clearable placeholder="备注" />
          </div>
          <div class="shaixuan-item expire-range">
            <el-date-picker
              v-model="filters.expire_range"
              type="daterange"
              size="mini"
              range-separator="至"
              :start-placeholder="expireDateLabel + '起'"
              :end-placeholder="expireDateLabel + '止'"
              value-format="yyyy-MM-dd"
            />
          </div>
        </template>
      </template>
      <div class="shaixuan-item">
        <el-button type="primary" size="mini" class="btn-primary-blue" icon="el-icon-search" @click="filterList">查询</el-button>
        <el-button size="mini" @click="resetFilters">重置</el-button>
        <el-button v-if="!readonly" type="primary" size="mini" class="btn-primary-blue" icon="el-icon-plus" @click="openForm()">新增</el-button>
        <el-button v-if="useJwsApi && !readonly" size="mini" icon="el-icon-upload2" @click="showImportModal">导入</el-button>
        <el-button size="mini" icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
      </div>
    </div>
    <div class="common-section-bg common-section-body table-wrap">
      <el-table v-loading="listLoading" :data="displayList" size="mini" style="width: 100%; min-height: 300px">
        <el-table-column prop="city" label="城市" width="80" />
        <el-table-column prop="project" label="项目" width="130" show-overflow-tooltip />
        <el-table-column prop="plate" label="车牌号" width="110" />
        <el-table-column prop="owner" label="业主" width="80" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.vehicle_type === '特殊' ? '—' : (scope.row.owner || '—') }}</template>
        </el-table-column>
        <el-table-column prop="room_no" label="业主房号" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.vehicle_type === '特殊' ? '—' : (scope.row.room_no || '—') }}</template>
        </el-table-column>
        <el-table-column v-if="useHikApi || !isPropertyMode" prop="id_card" label="身份证号" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.vehicle_type === '特殊' ? '—' : (scope.row.id_card || '—') }}</template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="115">
          <template slot-scope="scope">{{ scope.row.vehicle_type === '特殊' ? '—' : (scope.row.phone || '—') }}</template>
        </el-table-column>
        <el-table-column prop="nuoche_phone" label="挪车手机号" width="115" />
        <el-table-column prop="parking_space" label="车位" min-width="160" class-name="parking-space-cell">
          <template slot-scope="scope">
            <span class="parking-space-text">{{ scope.row.vehicle_type === '特殊' ? '—' : (scope.row.parking_space || '—') }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="useApi" prop="hik_expire_date" :label="expireDateLabel" width="110" />
        <el-table-column v-if="useApi" prop="fee_expire_date" label="车位费有效期" width="115">
          <template slot-scope="scope">{{ scope.row.vehicle_type === '特殊' ? '—' : (scope.row.fee_expire_date || '—') }}</template>
        </el-table-column>
        <el-table-column v-if="!useApi" prop="expire_date" label="有效期" width="105" />
        <el-table-column prop="vehicle_type" label="类型" width="75" />
        <el-table-column v-if="showPersonCode" prop="person_code" label="人员编码" width="100" show-overflow-tooltip />
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
        <el-table-column prop="abnormal" label="异常标记" min-width="220" class-name="abnormal-cell">
          <template slot-scope="scope">
            <div v-if="scope.row.abnormal" class="abnormal-text">
              <span
                v-for="(item, idx) in splitAbnormal(scope.row.abnormal)"
                :key="idx"
                class="abnormal-item"
              >{{ item }}</span>
            </div>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" :width="!readonly ? 210 : 210" fixed="right" align="center">
          <template slot-scope="scope">
            <div class="table-action-btns">
              <el-button type="primary" size="mini" class="btn-primary-blue" @click="showDetail(scope.row)">详情</el-button>
              <template v-if="!readonly">
                <el-button type="danger" size="mini" class="btn-edit-green" @click="openForm(scope.row)">修改</el-button>
                <el-button type="danger" size="mini" @click="handleRemove(scope.row)">删除</el-button>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="handlePagination"
      />
    </div>

    <el-dialog
      :custom-class="drawerDialogClass"
      :title="drawerTitle"
      :visible.sync="drawerVisible"
      :width="drawerMode === 'detail' ? '820px' : '640px'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      top="5vh"
    >
      <div class="chechang-dialog-body" :class="{ 'is-detail': drawerMode === 'detail' }">
        <div v-if="drawerMode === 'edit' && !readonly" class="vd-panel">
          <div class="vd-section vd-section-last vd-form-panel">
            <div class="vd-section-head">
              <span class="vd-section-bar" />
              <span>{{ form.id ? '编辑车辆信息' : '新增车辆信息' }}</span>
            </div>
            <el-form :model="form" label-width="120px">
          <template v-if="isHikAddForm">
            <el-form-item label="小区">
              <el-select v-model="form.community_id" filterable clearable placeholder="请选择小区" style="width:100%" @change="onCommunityChange">
                <el-option v-for="item in communityOptions" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="车牌号"><el-input v-model="form.plate" /></el-form-item>
            <el-form-item label="车辆类型">
              <el-radio-group v-model="form.vehicle_type" @change="onVehicleTypeChange">
                <el-radio v-for="item in formVehicleTypeOptions" :key="item" :label="item">{{ item }}</el-radio>
              </el-radio-group>
              <p v-if="isSpecialForm" class="upload-tip">特殊车辆仅落地车场，不绑定业主房号/车位；业主信息由系统调用车场接口时使用默认值</p>
            </el-form-item>
            <template v-if="!isSpecialForm">
            <el-form-item label="业主房号">
              <el-select
                v-model="form.room_no"
                filterable
                remote
                reserve-keyword
                clearable
                :disabled="!form.community_id"
                :loading="roomLoading"
                :placeholder="form.community_id ? '输入房号/业主/手机号搜索' : '请先选择小区'"
                style="width:100%"
                :remote-method="onRoomSearch"
                @focus="onRoomFocus"
                @change="onRoomChange"
              >
                <el-option
                  v-for="item in roomOptions"
                  :key="item.room_no"
                  :label="formatRoomLabel(item)"
                  :value="item.room_no"
                />
              </el-select>
              <p class="upload-tip">可先选业主房号带出车位，或下方直接选车位带出业主</p>
            </el-form-item>
            <el-form-item label="绑定车位">
              <el-select
                :key="'parking-space-' + (form.community_id || 0)"
                v-model="form.parking_space_id"
                filterable
                remote
                reserve-keyword
                clearable
                :disabled="!form.community_id"
                :loading="parkingSpaceLoading"
                :placeholder="form.community_id ? '可搜索车位号/房号/业主直接选择' : '请先选择小区'"
                style="width:100%"
                :remote-method="onParkingSpaceSearch"
                @focus="onParkingSpaceFocus"
                @change="onParkingSpaceChange"
              >
                <el-option v-for="item in parkingSpaceOptions" :key="item.id" :label="formatParkingSpaceLabel(item)" :value="normalizeParkingSpaceId(item.id)" />
              </el-select>
              <p class="upload-tip">可不选车位；未绑定车位将标记「未绑定车位」异常</p>
              <p v-if="form.parking_space_id" class="upload-tip">
                是否租车位：
                <el-tag :type="selectedParkingIsRent ? 'warning' : 'info'" size="mini">{{ selectedParkingIsRent ? '是' : '否' }}</el-tag>
                <span v-if="selectedParkingIsRent && selectedParkingRentTip" class="rent-extra-tip">{{ selectedParkingRentTip }}</span>
              </p>
            </el-form-item>
            <el-form-item label="业主"><el-input v-model="form.owner" disabled /></el-form-item>
            <el-form-item label="手机号"><el-input v-model="form.phone" disabled /></el-form-item>
            <el-form-item label="身份证号">
              <el-input v-model="form.id_card" :placeholder="selectedParkingIsRent ? '已从租车位带出租户身份证号' : '请输入身份证号'" />
            </el-form-item>
            <el-form-item label="车位信息"><el-input v-model="form.parking_space" disabled /></el-form-item>
            <el-form-item label="车位费有效期">
              <el-input v-model="form.fee_expire_date" disabled placeholder="选择房号/车位后自动带出" />
            </el-form-item>
            </template>
            <el-form-item label="挪车手机号"><el-input v-model="form.nuoche_phone" placeholder="请输入挪车手机号" /></el-form-item>
            <el-form-item label="海康车辆有效期">
              <el-date-picker
                v-model="form.hik_expire_date"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:100%"
                placeholder="海康车辆有效期"
                :disabled="!canEditHikExpire"
              />
              <p v-if="form.fee_expire_date && form.vehicle_type === '普通'" class="upload-tip">普通车按车位费有效期自动填写，不可直接改期</p>
              <p v-else-if="form.vehicle_type === '普通'" class="upload-tip">普通车无车位费有效期时可手填一次；保存后不可直接改期</p>
              <p v-else-if="form.vehicle_type === '延期'" class="upload-tip">延期车辆请填写有效期并上传附件</p>
              <p v-else-if="form.vehicle_type === '特殊'" class="upload-tip">特殊车辆将落地海康，可设置有效期并须上传附件</p>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="255" show-word-limit placeholder="选填备注" />
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item v-if="useApi && !form.id" label="小区">
              <el-select v-model="form.community_id" filterable clearable placeholder="请选择小区" style="width:100%" @change="onCommunityChange">
                <el-option v-for="item in communityOptions" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="车牌号"><el-input v-model="form.plate" /></el-form-item>
            <el-form-item label="车辆类型">
              <el-radio-group v-model="form.vehicle_type" @change="onVehicleTypeChange">
                <el-radio v-for="item in formVehicleTypeOptions" :key="item" :label="item">{{ item }}</el-radio>
              </el-radio-group>
              <p v-if="isSpecialForm" class="upload-tip">特殊车辆仅落地车场，不绑定业主房号/车位；业主信息由系统调用车场接口时使用默认值</p>
            </el-form-item>
            <template v-if="!isSpecialForm">
            <el-form-item v-if="isBindEditForm" label="业主房号">
              <el-select
                v-model="form.room_no"
                filterable
                remote
                reserve-keyword
                clearable
                :disabled="!form.community_id"
                :loading="roomLoading"
                :placeholder="form.community_id ? '输入房号/业主/手机号搜索' : '请先选择小区'"
                style="width:100%"
                :remote-method="onRoomSearch"
                @focus="onRoomFocus"
                @change="onEditRoomChange"
              >
                <el-option
                  v-for="item in roomOptions"
                  :key="item.room_no"
                  :label="formatRoomLabel(item)"
                  :value="item.room_no"
                />
              </el-select>
              <p class="upload-tip">可先选业主房号带出车位，或下方直接选车位带出业主</p>
            </el-form-item>
            <el-form-item v-if="useApi" label="绑定车位">
              <el-select
                :key="'parking-space-' + (form.community_id || 0)"
                v-model="form.parking_space_id"
                filterable
                remote
                reserve-keyword
                clearable
                :disabled="!form.community_id"
                :loading="parkingSpaceLoading"
                :placeholder="form.community_id ? '可搜索车位号/房号/业主直接选择' : '请先选择小区'"
                style="width:100%"
                :remote-method="onParkingSpaceSearch"
                @focus="onParkingSpaceFocus"
                @change="onParkingSpaceChange"
              >
                <el-option v-for="item in parkingSpaceOptions" :key="item.id" :label="formatParkingSpaceLabel(item)" :value="normalizeParkingSpaceId(item.id)" />
              </el-select>
              <p class="upload-tip">可不选车位；未绑定车位将标记「未绑定车位」异常</p>
              <p v-if="form.parking_space_id" class="upload-tip">
                是否租车位：
                <el-tag :type="selectedParkingIsRent ? 'warning' : 'info'" size="mini">{{ selectedParkingIsRent ? '是' : '否' }}</el-tag>
                <span v-if="selectedParkingIsRent && selectedParkingRentTip" class="rent-extra-tip">{{ selectedParkingRentTip }}</span>
              </p>
            </el-form-item>
            <el-form-item label="业主"><el-input v-model="form.owner" /></el-form-item>
            <el-form-item v-if="!isBindEditForm" label="业主房号"><el-input v-model="form.room_no" /></el-form-item>
            <el-form-item label="手机号"><el-input v-model="form.phone" @blur="lookupJwsPersonCode" /></el-form-item>
            <el-form-item v-if="useHikApi || useJwsApi" label="身份证号">
              <el-input v-model="form.id_card" :placeholder="selectedParkingIsRent ? '已从租车位带出租户身份证号' : '请输入身份证号'" />
            </el-form-item>
            <el-form-item v-if="useJwsApi" label="数量">
              <el-input v-model.number="form.shuliang" type="number" :min="1" placeholder="可绑车位数量" />
            </el-form-item>
            <el-form-item label="车位信息"><el-input v-model="form.parking_space" :disabled="isBindEditForm" /></el-form-item>
            <el-form-item v-if="useApi && form.fee_expire_date" label="车位费有效期">
              <el-input v-model="form.fee_expire_date" disabled />
            </el-form-item>
            </template>
            <el-form-item label="挪车手机号"><el-input v-model="form.nuoche_phone" placeholder="请输入挪车手机号" @blur="lookupJwsPersonCode" /></el-form-item>
            <el-form-item v-if="useJwsApi && !isSpecialForm" label="人员编码">
              <el-input v-model="form.person_code" clearable placeholder="可手填；失焦手机号可自动带出" />
            </el-form-item>
            <el-form-item :label="expireDateLabel">
              <el-date-picker
                v-model="form.hik_expire_date"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:100%"
                :placeholder="expireDateLabel"
                :disabled="!canEditHikExpire"
              />
              <p v-if="useApi && form.vehicle_type === '普通'" class="upload-tip">普通车辆不可直接改期（捷卫士新增默认 30 天）；改期请用「延期」或「特殊」</p>
              <p v-else-if="useApi && form.vehicle_type === '特殊'" class="upload-tip">特殊车辆将落地捷卫士/海康，可设置有效期</p>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="255" show-word-limit placeholder="选填备注" />
            </el-form-item>
          </template>
          <el-form-item v-if="showSpecialAttachment" label="流程截图/附件">
            <el-upload
              v-if="useApi"
              action="/c-api/common/uploadFile"
              name="imgFile"
              :headers="uploadHeaders"
              :limit="1"
              :file-list="formAttachmentList"
              :on-success="onFormUploadSuccess"
              :on-error="onFormUploadError"
              :on-remove="handleAttachmentRemove"
              accept="image/*,.pdf,.doc,.docx"
            >
              <el-button size="mini" type="primary" class="btn-primary-blue" icon="el-icon-upload2">上传附件</el-button>
            </el-upload>
            <el-upload
              v-else
              action="#"
              :auto-upload="false"
              :limit="1"
              :file-list="formAttachmentList"
              :on-change="handleAttachmentChange"
              :on-remove="handleAttachmentRemove"
              accept="image/*,.pdf,.doc,.docx"
            >
              <el-button size="mini" type="primary" class="btn-primary-blue" icon="el-icon-upload2">选择文件</el-button>
            </el-upload>
            <p class="upload-tip">特殊车辆需上传审批流程截图或附件</p>
          </el-form-item>
          <el-form-item v-if="showExtendAttachment" label="延期附件" required>
            <el-upload
              action="/c-api/common/uploadFile"
              name="imgFile"
              :headers="uploadHeaders"
              :limit="1"
              :file-list="extendAttachmentList"
              :on-success="onExtendAttachmentSuccess"
              :on-error="onExtendAttachmentError"
              :on-remove="onExtendAttachmentRemove"
              accept="image/*,.pdf,.doc,.docx"
            >
              <el-button size="mini" type="primary" class="btn-primary-blue" icon="el-icon-upload2">上传延期附件</el-button>
            </el-upload>
            <p class="upload-tip">修改有效期必须上传延期审批附件</p>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="btn-primary-blue" :loading="saveLoading" @click="saveForm">保存</el-button>
          </el-form-item>
            </el-form>
          </div>
        </div>
        <div v-else class="vehicle-detail">
          <div class="vd-hero">
            <div class="vd-hero-main">
              <div class="vd-plate">{{ detailRow.plate || '—' }}</div>
              <div class="vd-hero-tags">
                <el-tag size="small" effect="dark" :type="vehicleTypeTagType">{{ detailRow.vehicle_type || '未分类' }}</el-tag>
                <el-tag size="small" :type="detailRow.in_garage === '是' ? 'success' : 'info'">
                  {{ detailRow.in_garage === '是' ? '在库' : '不在库' }}
                </el-tag>
                <el-tag size="small" type="info" effect="plain">{{ systemLabel }}</el-tag>
              </div>
            </div>
            <div v-if="!isSpecialDetail" class="vd-hero-side">
              <div class="vd-hero-owner">
                <span class="vd-hero-label">业主</span>
                <span class="vd-hero-value">{{ detailRow.owner || '—' }}</span>
              </div>
              <div class="vd-hero-owner">
                <span class="vd-hero-label">手机</span>
                <span class="vd-hero-value">{{ detailRow.phone || '—' }}</span>
              </div>
            </div>
            <div v-else class="vd-hero-side">
              <div class="vd-hero-owner">
                <span class="vd-hero-label">挪车手机</span>
                <span class="vd-hero-value">{{ detailRow.nuoche_phone || '—' }}</span>
              </div>
            </div>
          </div>

          <div v-if="!isSpecialDetail" class="vd-section">
            <div class="vd-section-head">
              <span class="vd-section-bar" />
              <span>车位与房号</span>
            </div>
            <div class="vd-grid">
              <div class="vd-cell vd-cell-wide">
                <span class="vd-lab">车位信息</span>
                <span class="vd-val">{{ detailRow.parking_space || '—' }}</span>
              </div>
              <div class="vd-cell">
                <span class="vd-lab">业主房号</span>
                <span class="vd-val">{{ detailRow.room_no || '—' }}</span>
              </div>
            </div>
          </div>

          <div v-if="useApi" class="vd-section">
            <div class="vd-section-head">
              <span class="vd-section-bar" />
              <span>有效期</span>
            </div>
            <div class="vd-expire-grid" :class="{ 'vd-expire-grid-single': isSpecialDetail }">
              <div class="vd-expire-card">
                <div class="vd-expire-label">{{ expireDateLabel }}</div>
                <div class="vd-expire-value">{{ detailRow.hik_expire_date || '—' }}</div>
              </div>
              <div v-if="!isSpecialDetail" class="vd-expire-card">
                <div class="vd-expire-label">车位费有效期</div>
                <div class="vd-expire-value-row">
                  <span class="vd-expire-value">{{ detailRow.fee_expire_date || '—' }}</span>
                  <el-button
                    v-if="canSyncParkingFee"
                    type="primary"
                    size="mini"
                    class="btn-primary-blue"
                    icon="el-icon-refresh"
                    :loading="syncingParkingFee"
                    :disabled="!detailRow.id"
                    @click="syncParkingFee"
                  >同步物业费</el-button>
                </div>
              </div>
            </div>
          </div>

          <div class="vd-section">
            <div class="vd-section-head">
              <span class="vd-section-bar" />
              <span>基本信息</span>
            </div>
            <div class="vd-grid">
              <div v-for="item in detailInfoGrid" :key="item.key" class="vd-cell">
                <span class="vd-lab">{{ item.label }}</span>
                <span class="vd-val">{{ item.value }}</span>
              </div>
              <div class="vd-cell vd-cell-action">
                <span class="vd-lab">是否在库</span>
                <div class="vd-val-row">
                  <el-tag size="mini" :type="detailRow.in_garage === '是' ? 'success' : 'info'">
                    {{ detailRow.in_garage === '是' ? '在库' : (detailRow.in_garage || '—') }}
                  </el-tag>
                  <el-button
                    type="primary"
                    size="mini"
                    class="btn-primary-blue"
                    icon="el-icon-refresh"
                    :loading="queryingGarage"
                    @click="queryRealtimeGarage"
                  >实时查询</el-button>
                </div>
                <p v-if="realtimeGarageResult" class="vd-realtime-tip">
                  实时：
                  <el-tag :type="realtimeGarageResult.status === '是' ? 'success' : 'info'" size="mini">
                    {{ realtimeGarageResult.status === '是' ? '在库' : '不在库' }}
                  </el-tag>
                  <span class="vd-query-time">{{ realtimeGarageResult.time }}</span>
                </p>
              </div>
              <div
                v-if="detailRow.vehicle_type !== '普通' && (detailRow.attachment_url || detailRow.attachment_name)"
                class="vd-cell vd-cell-wide"
              >
                <span class="vd-lab">流程附件</span>
                <span class="vd-val">
                  <a
                    v-if="detailRow.attachment_url"
                    :href="detailRow.attachment_url"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="attachment-link"
                  >{{ detailRow.attachment_name || '查看附件' }}</a>
                  <template v-else>{{ detailRow.attachment_name || '—' }}</template>
                </span>
              </div>
              <div v-if="useApi" class="vd-cell vd-cell-wide">
                <span class="vd-lab">备注</span>
                <span class="vd-val">{{ detailRow.remark || '—' }}</span>
              </div>
              <div v-if="useJwsApi" class="vd-cell">
                <span class="vd-lab">人员编码</span>
                <span class="vd-val">{{ detailRow.person_code || '—' }}</span>
              </div>
            </div>
          </div>

          <div class="vd-section">
            <div class="vd-section-head">
              <span class="vd-section-bar" />
              <span>出入记录</span>
              <span class="vd-section-count">{{ detailCrossRecords.length }}</span>
            </div>
            <el-table
              v-loading="crossRecordsLoading"
              :data="detailCrossRecords"
              size="mini"
              class="vd-table"
              stripe
              style="width: 100%"
            >
              <el-table-column prop="direction" label="方向" width="70" />
              <el-table-column prop="gate" label="通道" min-width="120" show-overflow-tooltip />
              <el-table-column prop="time" label="时间" width="150" show-overflow-tooltip>
                <template slot-scope="scope">{{ formatDateTime(scope.row.time) }}</template>
              </el-table-column>
            </el-table>
            <p v-if="!crossRecordsLoading && !detailCrossRecords.length" class="empty-tip">暂无出入记录</p>
          </div>

          <div class="vd-section vd-section-last">
            <div class="vd-section-head">
              <span class="vd-section-bar" />
              <span>延期操作日志</span>
              <span class="vd-section-count">{{ detailRenewalLogs.length }}</span>
            </div>
            <el-table
              v-if="detailRenewalLogs.length"
              :data="detailRenewalLogs"
              size="mini"
              class="vd-table"
              stripe
            >
              <el-table-column prop="operator" label="操作人" width="80" />
              <el-table-column label="操作时间" min-width="150">
                <template slot-scope="scope">{{ formatDateTime(scope.row.operate_time) }}</template>
              </el-table-column>
              <el-table-column prop="old_date" label="原日期" width="105" />
              <el-table-column prop="new_date" label="延期日期" width="105" />
              <el-table-column label="附件" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a
                    v-if="scope.row.attachment_url"
                    :href="scope.row.attachment_url"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="attachment-link"
                  >{{ scope.row.attachment_name || '查看' }}</a>
                  <span v-else>—</span>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip />
            </el-table>
            <p v-else class="empty-tip">暂无延期操作记录</p>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      v-if="useJwsApi"
      custom-class="chechang-form-dialog"
      :visible.sync="importModalVisible"
      title="捷卫士车辆 Excel 导入"
      width="560px"
      append-to-body
      @closed="resetImportModal"
    >
      <div class="chechang-dialog-body vd-panel">
        <div class="vd-section vd-section-last vd-form-panel">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>导入文件</span>
          </div>
          <p class="upload-tip" style="margin-top:0;margin-bottom:12px">请上传捷卫士导出的 Excel 文件，格式与老版导入一致。</p>
          <el-form label-width="80px">
            <el-form-item label="小区" required>
              <el-select
                v-model="importCommunityId"
                filterable
                clearable
                placeholder="请选择小区"
                style="width:100%"
              >
                <el-option v-for="item in communityOptions" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="文件" required>
              <upload-xlsx
                ref="importUpload"
                tip-info="支持 xls、xlsx"
                :image-list="importFileDefaultList"
                :max-number="1"
                @updateImg="onImportFileUpdate"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="importModalVisible = false">取消</el-button>
        <el-button type="primary" class="btn-primary-blue" :loading="importLoading" @click="submitImport">确定导入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import UploadXlsx from '@/components/UploadExcel/index.vue'
import { cityOptions, projectOptions, accessRecords } from '../mockData'
import chechangHikVehicle from '@/api/tianzheng/chechangHikVehicle'
import chechangJwsVehicle from '@/api/tianzheng/chechangJwsVehicle'
import { getToken } from '@/utils/auth'
import { parseTime } from '@/utils'

const defaultFilters = () => ({
  city: '',
  project: '',
  plate: '',
  owner: '',
  id_card: '',
  phone: '',
  room_no: '',
  in_garage: '',
  vehicle_type: '',
  abnormal: '',
  parking_space: '',
  remark: '',
  expire_range: null
})

const defaultForm = () => ({
  plate: '',
  owner: '',
  room_no: '',
  phone: '',
  id_card: '',
  nuoche_phone: '',
  parking_space: '',
  parking_space_id: null,
  community_id: null,
  hik_expire_date: '',
  fee_expire_date: '',
  expire_date: '',
  vehicle_type: '普通',
  person_code: '',
  shuliang: 1,
  remark: '',
  attachment_name: '',
  attachment_url: ''
})

export default {
  name: 'VehicleManagePanel',
  components: { Pagination, UploadXlsx },
  props: {
    title: { type: String, default: '' },
    source: { type: String, default: 'hik' },
    readonly: { type: Boolean, default: false },
    extendedFilters: { type: Boolean, default: false },
    showPersonCode: { type: Boolean, default: false },
    useHikApi: { type: Boolean, default: false },
    useJwsApi: { type: Boolean, default: false },
    list: { type: Array, default: () => [] }
  },
  data() {
    return {
      cityOptions,
      projectOptions,
      accessRecords,
      vehicleTypeOptions: ['普通', '延期', '特殊'],
      formVehicleTypeOptions: ['普通', '延期', '特殊'],
      abnormalTypeOptions: ['有效期异常', '海康车辆有效期异常', '捷卫士有效期异常', '车位费有效期异常', '一位多车', '车位信息不一致', '缺少人员编码', '未绑定车位', '车场新增'],
      tableData: [],
      displayList: [],
      filters: defaultFilters(),
      drawerVisible: false,
      drawerMode: 'detail',
      form: defaultForm(),
      formAttachmentList: [],
      detailRow: {},
      queryingGarage: false,
      syncingParkingFee: false,
      realtimeGarageResult: null,
      communityOptions: [],
      roomOptions: [],
      allParkingSpaceOptions: [],
      parkingSpaceOptions: [],
      selectedParkingSpace: null,
      parkingSpaceLoading: false,
      roomLoading: false,
      roomSearchTimer: null,
      parkingSpaceSearchTimer: null,
      syncingFromParking: false,
      communityMap: {},
      listLoading: false,
      exportLoading: false,
      listQuery: { page: 1, size: 10 },
      total: 0,
      formOriginalHikExpireDate: '',
      extendAttachmentList: [],
      uploadHeaders: { Authorization: getToken() },
      crossRecords: [],
      crossRecordsLoading: false,
      saveLoading: false,
      importModalVisible: false,
      importLoading: false,
      importCommunityId: null,
      importFileList: [],
      importFileDefaultList: []
    }
  },
  computed: {
    useApi() {
      return this.useHikApi || this.useJwsApi
    },
    vehicleApi() {
      return this.useJwsApi ? chechangJwsVehicle : chechangHikVehicle
    },
    isHikAddForm() {
      return this.useHikApi && !this.form.id && this.drawerMode === 'edit'
    },
    isHikEditForm() {
      return this.useHikApi && !!this.form.id && this.drawerMode === 'edit'
    },
    isJwsEditForm() {
      return this.useJwsApi && !!this.form.id && this.drawerMode === 'edit'
    },
    isJwsAddForm() {
      return this.useJwsApi && !this.form.id && this.drawerMode === 'edit'
    },
    isBindEditForm() {
      return this.isHikEditForm || this.isJwsEditForm || this.isJwsAddForm
    },
    expireDateLabel() {
      if (this.useJwsApi) return '捷卫士有效期'
      if (this.useHikApi) return '海康车辆有效期'
      return '有效期'
    },
    systemLabel() {
      if (this.useJwsApi) return '捷卫士'
      if (this.useHikApi) return '海康'
      return this.source === 'hik' ? '海康' : '捷卫士'
    },
    isPropertyMode() {
      return !this.readonly
    },
    canSyncParkingFee() {
      return this.useApi && this.isPropertyMode && !this.isSpecialDetail
    },
    isSpecialForm() {
      return this.form.vehicle_type === '特殊'
    },
    isSpecialDetail() {
      return this.detailRow.vehicle_type === '特殊'
    },
    drawerDialogClass() {
      return this.drawerMode === 'detail'
        ? 'chechang-form-dialog chechang-detail-dialog'
        : 'chechang-form-dialog'
    },
    vehicleTypeTagType() {
      const type = this.detailRow.vehicle_type
      if (type === '延期') return 'warning'
      if (type === '特殊') return 'danger'
      return ''
    },
    detailInfoGrid() {
      const skip = new Set(['plate', 'owner', 'phone', 'vehicle_type', 'in_garage'])
      if (this.isSpecialDetail) {
        ;['room_no', 'id_card', 'parking_space', 'fee_expire_date', 'space_expire_date'].forEach(k => skip.add(k))
      }
      const fields = this.detailFieldsWithoutGarage
      return Object.keys(fields)
        .filter(key => !skip.has(key))
        .map(key => ({
          key,
          label: fields[key],
          value: this.detailRow[key] || '—'
        }))
    },
    drawerTitle() {
      if (this.drawerMode === 'edit') {
        return this.form.id ? '编辑车辆' : '新增车辆'
      }
      return '车辆详情'
    },
    projectSelectOptions() {
      if (this.useApi) {
        return this.communityOptions.map(item => item.name)
      }
      if (this.isPropertyMode || !this.filters.city) {
        return this.projectOptions.map(item => item.name)
      }
      return this.projectOptions
        .filter(item => item.city === this.filters.city)
        .map(item => item.name)
    },
    detailFields() {
      const fields = {
        plate: '车牌号',
        owner: '业主',
        phone: '手机号',
        nuoche_phone: '挪车手机号',
        vehicle_type: '类型',
        in_garage: '是否在库'
      }
      // useApi 时有效期已单独展示为「捷卫士/海康有效期」，避免再出一列「有效期」
      if (!this.useApi) {
        fields.expire_date = '有效期'
      }
      if (this.useHikApi || !this.isPropertyMode) {
        fields.id_card = '身份证号'
      }
      return fields
    },
    detailFieldsWithoutGarage() {
      const fields = { ...this.detailFields }
      delete fields.in_garage
      return fields
    },
    detailRenewalLogs() {
      return this.detailRow.renewal_logs || []
    },
    detailCrossRecords() {
      if (this.useApi) {
        return this.crossRecords
      }
      return accessRecords
        .filter(item => item.plate === this.detailRow.plate)
        .slice(0, 10)
    },
    canEditHikExpire() {
      if (!this.useApi) return true
      // 编辑：仅延期/特殊可改期；普通禁止直接改期
      if (this.form.id) {
        return this.form.vehicle_type === '延期' || this.form.vehicle_type === '特殊'
      }
      // 新增：延期/特殊可填；普通捷卫士默认30天不可填；海康普通无车位费时可手填一次
      if (this.form.vehicle_type === '延期' || this.form.vehicle_type === '特殊') return true
      if (this.useJwsApi) return false
      return !this.form.fee_expire_date
    },
    isExtendExpireChanged() {
      return String(this.form.hik_expire_date || '') !== String(this.formOriginalHikExpireDate || '')
    },
    isExpireExtended() {
      const newDate = this.form.hik_expire_date
      const oldDate = this.formOriginalHikExpireDate
      if (!newDate) return false
      if (!oldDate) return true
      return new Date(newDate).getTime() > new Date(oldDate).getTime()
    },
    showSpecialAttachment() {
      return this.form.vehicle_type === '特殊'
    },
    showExtendAttachment() {
      return this.useApi && this.form.vehicle_type === '延期' && this.isExtendExpireChanged
    },
    selectedParkingIsRent() {
      const space = this.selectedParkingSpace
      if (!space) return false
      return Number(space.is_rent) === 1 || space.rent_status === '已租'
    },
    selectedParkingRentTip() {
      if (!this.selectedParkingIsRent || !this.selectedParkingSpace) return ''
      const parts = []
      if (this.selectedParkingSpace.tenant_name) parts.push('租户：' + this.selectedParkingSpace.tenant_name)
      if (this.selectedParkingSpace.rent_start || this.selectedParkingSpace.rent_end) {
        parts.push('租期：' + (this.selectedParkingSpace.rent_start || '—') + ' ~ ' + (this.selectedParkingSpace.rent_end || '—'))
      }
      return parts.join('；')
    }
  },
  created() {
    if (this.useApi) {
      this.initVehicleApi()
    } else {
      this.tableData = JSON.parse(JSON.stringify(this.list))
      this.refreshMockPage()
    }
  },
  methods: {
    formatDateTime(time) {
      if (!time) return '—'
      if (typeof time === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(time)) {
        return time
      }
      return parseTime(time) || time
    },
    handlePagination() {
      if (this.useApi) {
        this.fetchList()
      } else {
        this.refreshMockPage()
      }
    },
    getFilteredMockRows() {
      return this.tableData.filter(row => {
        if (this.filters.project && row.project !== this.filters.project) return false
        if (this.filters.plate && !row.plate.includes(this.filters.plate)) return false
        if (this.filters.owner && !String(row.owner).includes(this.filters.owner)) return false
        if (this.isPropertyMode) {
          if (this.filters.room_no && !String(row.room_no || '').includes(this.filters.room_no)) return false
          if (this.filters.parking_space && !String(row.parking_space || '').includes(this.filters.parking_space)) return false
          if (this.filters.phone && !String(row.phone || '').includes(this.filters.phone) && !String(row.nuoche_phone || '').includes(this.filters.phone)) return false
          if (!this.matchAbnormalFilter(row)) return false
          return true
        }
        if (this.filters.city && row.city !== this.filters.city) return false
        if (this.extendedFilters) {
          if (this.filters.id_card && !String(row.id_card).includes(this.filters.id_card)) return false
          if (this.filters.phone && !String(row.phone).includes(this.filters.phone)) return false
          if (this.filters.in_garage && row.in_garage !== this.filters.in_garage) return false
          if (this.filters.vehicle_type && row.vehicle_type !== this.filters.vehicle_type) return false
          if (this.filters.parking_space && !String(row.parking_space).includes(this.filters.parking_space)) return false
          if (!this.matchAbnormalFilter(row)) return false
          if (this.filters.expire_range && this.filters.expire_range.length === 2) {
            const [start, end] = this.filters.expire_range
            const expire = row.hik_expire_date || row.jws_expire_date || row.expire_date
            if (!expire || expire < start || expire > end) return false
          }
        }
        return true
      })
    },
    refreshMockPage() {
      const filtered = this.getFilteredMockRows()
      this.total = filtered.length
      const start = (this.listQuery.page - 1) * this.listQuery.size
      this.displayList = filtered.slice(start, start + this.listQuery.size)
    },
    initVehicleApi() {
      // 列表与筛选项并行请求，避免先等小区下拉再加载造成空白卡顿
      this.fetchList()
      this.vehicleApi.communitySelect().then(res => {
        if (res.code === 200) {
          this.communityOptions = res.result || []
          this.communityMap = {}
          this.communityOptions.forEach(item => { this.communityMap[item.name] = item.id })
        }
      }).catch(() => {})
      if (!this.isPropertyMode) {
        this.vehicleApi.cityOptions().then(res => {
          if (res.code === 200) this.cityOptions = res.result || []
        }).catch(() => {})
      }
    },
    fetchList() {
      if (!this.useApi) return
      this.listLoading = true
      const params = {
        ...this.buildListParams(),
        page: this.listQuery.page,
        size: this.listQuery.size
      }
      this.vehicleApi.list(params).then(res => {
        this.listLoading = false
        if (res.code === 200) {
          this.tableData = res.result.list || []
          this.displayList = this.tableData
          this.total = res.result.total || 0
        }
      }).catch(() => { this.listLoading = false })
    },
    buildListParams() {
      const params = {
        plate: this.filters.plate,
        owner: this.filters.owner,
        phone: this.filters.phone,
        room_no: this.filters.room_no,
        parking_space: this.filters.parking_space,
        abnormal: this.filters.abnormal,
        city: this.filters.city,
        vehicle_type: this.filters.vehicle_type,
        in_garage: this.filters.in_garage,
        id_card: this.filters.id_card
      }
      if (this.filters.project && this.communityMap[this.filters.project]) {
        params.community_id = this.communityMap[this.filters.project]
      }
      if (this.filters.expire_range && this.filters.expire_range.length === 2) {
        params.expire_start = this.filters.expire_range[0]
        params.expire_end = this.filters.expire_range[1]
      }
      return params
    },
    formatParkingSpaceLabel(item) {
      if (!item) return ''
      const parts = [item.space_no || item.parking_space]
      if (Number(item.is_rent) === 1 || item.rent_status === '已租') parts.unshift('[租]')
      if (item.room_no) parts.push(item.room_no)
      if (item.owner_name) parts.push(item.owner_name)
      return parts.filter(Boolean).join(' - ')
    },
    normalizeParkingSpaceId(id) {
      if (id === null || id === undefined || id === '') return null
      const num = Number(id)
      return Number.isNaN(num) ? id : num
    },
    normalizeParkingSpaceOption(item) {
      if (!item) return item
      return { ...item, id: this.normalizeParkingSpaceId(item.id) }
    },
    normalizeParkingSpaceOptions(list) {
      return (list || []).map(item => this.normalizeParkingSpaceOption(item))
    },
    ensureParkingSpaceOption(space) {
      if (!space || space.id === undefined || space.id === null) return
      const id = this.normalizeParkingSpaceId(space.id)
      if (!this.parkingSpaceOptions.some(item => this.normalizeParkingSpaceId(item.id) === id)) {
        this.parkingSpaceOptions = [this.normalizeParkingSpaceOption(space), ...this.parkingSpaceOptions]
      }
    },
    buildParkingSpaceFromRow(row) {
      if (!row || row.parking_space_id === null || row.parking_space_id === undefined || row.parking_space_id === '') {
        return null
      }
      return this.normalizeParkingSpaceOption({
        id: row.parking_space_id,
        space_no: row.parking_space,
        parking_space: row.parking_space,
        room_no: row.room_no,
        owner_name: row.owner,
        owner_phone: row.phone,
        fee_expire_date: row.fee_expire_date
      })
    },
    ensureRoomOption(roomNo, owner = '', phone = '') {
      if (!roomNo) return
      if (!this.roomOptions.some(item => item.room_no === roomNo)) {
        this.roomOptions = [{ room_no: roomNo, owner_name: owner, owner_phone: phone }, ...this.roomOptions]
      }
    },
    formatRoomLabel(item) {
      const parts = [item.room_no]
      if (item.owner_name) parts.push(item.owner_name)
      if (item.parking_space_count) parts.push(item.parking_space_count + '个车位')
      return parts.filter(Boolean).join(' - ')
    },
    splitAbnormal(text) {
      if (!text) return []
      return String(text).split(',').map(item => item.trim()).filter(Boolean)
    },
    resetHikAddBindFields() {
      this.form.room_no = ''
      this.form.parking_space_id = null
      this.form.parking_space = ''
      this.form.owner = ''
      this.form.phone = ''
      this.form.id_card = ''
      this.form.fee_expire_date = ''
      this.form.hik_expire_date = ''
      this.formOriginalHikExpireDate = ''
      this.roomOptions = []
      this.allParkingSpaceOptions = []
      this.parkingSpaceOptions = []
      this.selectedParkingSpace = null
    },
    resetParkingSpaceFormFields() {
      if (this.isHikAddForm) {
        this.resetHikAddBindFields()
        return
      }
      this.form.parking_space_id = null
      this.form.parking_space = ''
      this.form.owner = ''
      this.form.room_no = ''
      this.form.phone = ''
      this.form.id_card = ''
      this.form.fee_expire_date = ''
      this.form.hik_expire_date = ''
      this.formOriginalHikExpireDate = ''
      this.selectedParkingSpace = null
      this.parkingSpaceOptions = []
      this.allParkingSpaceOptions = []
      this.roomOptions = []
    },
    resolveFilterCommunityId() {
      if (this.filters.project && this.communityMap[this.filters.project]) {
        return this.communityMap[this.filters.project]
      }
      return null
    },
    onCommunityChange(communityId) {
      this.resetParkingSpaceFormFields()
      if (!communityId) return
      if (this.isHikAddForm || this.isJwsAddForm || this.isBindEditForm) {
        this.loadRoomOptions(communityId, '')
        this.loadParkingSpaces(communityId, '')
      } else {
        this.loadParkingSpaces(communityId)
      }
    },
    onRoomFocus() {
      if (!this.form.community_id || this.roomLoading) return
      if (!this.roomOptions.length || (this.isBindEditForm && this.roomOptions.length <= 1)) {
        this.loadRoomOptions(this.form.community_id, '')
      }
    },
    onRoomSearch(keyword) {
      if (!this.form.community_id) return
      clearTimeout(this.roomSearchTimer)
      this.roomSearchTimer = setTimeout(() => {
        this.loadRoomOptions(this.form.community_id, keyword || '')
      }, 300)
    },
    onParkingSpaceFocus() {
      if (!this.form.community_id || this.parkingSpaceLoading) return
      if (this.form.room_no) {
        if (!this.parkingSpaceOptions.length || this.parkingSpaceOptions.length <= 1) {
          this.loadParkingSpacesForRoom(this.form.community_id, this.form.room_no)
        }
        return
      }
      if (!this.parkingSpaceOptions.length || this.parkingSpaceOptions.length <= 1) {
        this.loadParkingSpaces(this.form.community_id, '')
      }
    },
    onParkingSpaceSearch(keyword) {
      if (!this.form.community_id) return
      clearTimeout(this.parkingSpaceSearchTimer)
      this.parkingSpaceSearchTimer = setTimeout(() => {
        const kw = String(keyword || '').trim()
        if (this.form.room_no && !kw) {
          this.loadParkingSpacesForRoom(this.form.community_id, this.form.room_no)
        } else {
          this.loadParkingSpaces(this.form.community_id, kw, this.form.room_no || '')
        }
      }, 300)
    },
    loadRoomOptions(communityId, keyword = '') {
      if (!communityId || !this.useApi || !this.vehicleApi.roomSelect) {
        this.roomOptions = []
        this.roomLoading = false
        return
      }
      this.roomLoading = true
      const isSearch = !!String(keyword || '').trim()
      this.vehicleApi.roomSelect({
        community_id: communityId,
        keyword: keyword || '',
        limit: isSearch ? 50 : 500
      }).then(res => {
        if (res.code === 200) {
          const list = res.result || []
          this.roomOptions = list
          if (this.form.room_no) {
            this.ensureRoomOption(this.form.room_no, this.form.owner, this.form.phone)
          }
          if (!isSearch && !this.roomOptions.length) {
            this.$message.warning('该小区暂无房号数据，请先同步车位信息')
          }
        } else {
          this.$message.error(res.message || '加载房号列表失败')
        }
      }).catch(() => {
        this.$message.error('加载房号列表失败')
      }).finally(() => {
        this.roomLoading = false
      })
    },
    parkingBelongsToRoom(roomNo) {
      if (!roomNo || !this.selectedParkingSpace) return false
      return String(this.selectedParkingSpace.room_no || '').trim() === String(roomNo).trim()
    },
    onRoomChange(roomNo) {
      if (this.syncingFromParking) return

      const keepParking = this.parkingBelongsToRoom(roomNo)
      if (!keepParking) {
        this.form.parking_space_id = null
        this.form.parking_space = ''
        this.form.fee_expire_date = ''
        this.form.hik_expire_date = ''
        this.formOriginalHikExpireDate = ''
        this.form.id_card = ''
        this.selectedParkingSpace = null
      }

      if (!roomNo) {
        this.form.owner = ''
        this.form.phone = ''
        if (!keepParking) {
          this.parkingSpaceOptions = []
        }
        return
      }

      const room = this.roomOptions.find(item => item.room_no === roomNo)
      if (room) {
        this.form.owner = room.owner_name || ''
        this.form.phone = room.owner_phone || ''
        if (!keepParking && room.fee_expire_date) {
          this.form.fee_expire_date = room.fee_expire_date
        }
      }
      if (!keepParking) {
        this.applyHikExpireFromFee()
        this.loadParkingSpacesForRoom(this.form.community_id, roomNo)
      }
    },
    onEditRoomChange(roomNo) {
      if (this.syncingFromParking) return

      const keepParking = this.parkingBelongsToRoom(roomNo)
      if (!keepParking) {
        this.form.parking_space_id = null
        this.form.parking_space = ''
        this.selectedParkingSpace = null
        if (!this.form.id) {
          this.form.id_card = ''
        }
      }

      if (!roomNo) {
        if (!keepParking) {
          this.parkingSpaceOptions = []
        }
        if (this.useJwsApi) {
          this.form.owner = ''
          this.form.phone = ''
          this.form.nuoche_phone = ''
          this.form.shuliang = 1
        }
        return
      }

      const room = this.roomOptions.find(item => item.room_no === roomNo)
      if (room) {
        if (this.useJwsApi) {
          this.form.owner = room.owner_name || ''
          this.form.phone = room.owner_phone || ''
          this.form.nuoche_phone = room.owner_phone || ''
          this.form.shuliang = Math.max(1, parseInt(room.parking_space_count, 10) || 1)
        } else {
          this.form.owner = room.owner_name || this.form.owner
          this.form.phone = room.owner_phone || this.form.phone
        }
        if (!keepParking && room.fee_expire_date) {
          this.form.fee_expire_date = room.fee_expire_date
        }
      }
      if (!keepParking) {
        this.loadParkingSpacesForRoom(this.form.community_id, roomNo)
      }
      if (this.useJwsApi) {
        this.lookupJwsPersonCode()
      }
    },
    loadParkingSpacesForRoom(communityId, roomNo) {
      if (!communityId || !roomNo) {
        this.parkingSpaceOptions = []
        this.parkingSpaceLoading = false
        return
      }
      this.parkingSpaceLoading = true
      this.parkingSpaceOptions = []
      const existingSpaceNo = (this.form.parking_space || '').trim()
      this.vehicleApi.parkingSpaceSelect({
        community_id: communityId,
        room_no: roomNo,
        limit: 50
      }).then(res => {
        if (res.code !== 200) {
          this.$message.error(res.message || '加载车位列表失败')
          return null
        }
        let list = this.normalizeParkingSpaceOptions(res.result || [])
        // 房号下无结果时，用已有车位号关键字补查（兼容 room_no 未回填的车库）
        if (!list.length && existingSpaceNo) {
          return this.vehicleApi.parkingSpaceSelect({
            community_id: communityId,
            keyword: existingSpaceNo,
            limit: 50
          }).then(kwRes => {
            if (kwRes.code === 200) {
              list = this.normalizeParkingSpaceOptions(kwRes.result || [])
            }
            return list
          })
        }
        return list
      }).then(list => {
        if (!list) return
        this.parkingSpaceOptions = list
        if (!list.length) {
          // 已有车位文本时不误报「暂无车位」（常见于仅有 parking_space 无 id）
          if (!existingSpaceNo && !this.form.parking_space_id) {
            this.$message.warning('该房号下暂无车位，可不绑车位继续保存（将标记未绑定车位异常）')
          }
          return
        }
        if (list.length === 1 && (this.isHikAddForm || this.isJwsAddForm) && !this.form.parking_space_id) {
          this.applyParkingSpaceBinding(list[0])
        } else {
          this.syncSelectedParkingSpaceFromOptions(list)
        }
      }).catch(() => {
        this.$message.error('加载车位列表失败')
      }).finally(() => {
        this.parkingSpaceLoading = false
      })
    },
    applyParkingSpaceBinding(space) {
      if (!space) return
      const normalized = this.normalizeParkingSpaceOption(space)
      this.selectedParkingSpace = normalized
      this.form.parking_space_id = normalized.id
      this.form.parking_space = normalized.space_no || ''
      const isRent = Number(normalized.is_rent) === 1 || normalized.rent_status === '已租'
      const keepRoomContact = this.useJwsApi && this.isBindEditForm && this.form.room_no
      if (!keepRoomContact) {
        if (normalized.owner_name) this.form.owner = normalized.owner_name
        if (isRent && normalized.tenant_phone) {
          this.form.phone = normalized.tenant_phone
        } else if (normalized.owner_phone) {
          this.form.phone = normalized.owner_phone
        }
      } else if (isRent && normalized.tenant_phone) {
        this.form.phone = normalized.tenant_phone
      }
      if (isRent) {
        if (normalized.tenant_id_card) this.form.id_card = normalized.tenant_id_card
      } else if (!this.form.id) {
        this.form.id_card = ''
      }
      if (normalized.room_no) {
        this.ensureRoomOption(normalized.room_no, normalized.owner_name || this.form.owner, normalized.owner_phone || this.form.phone)
        this.syncingFromParking = true
        this.form.room_no = normalized.room_no
        this.$nextTick(() => {
          this.syncingFromParking = false
        })
      }
      if (normalized.fee_expire_date) {
        this.form.fee_expire_date = normalized.fee_expire_date
      }
      this.ensureParkingSpaceOption(normalized)
      this.applyHikExpireFromFee()
      if (this.useJwsApi) {
        this.lookupJwsPersonCode()
      }
    },
    matchParkingSpaceOptionBySpaceNo(list, spaceNo) {
      const target = String(spaceNo || '').trim()
      if (!target) return null
      const strip = (v) => String(v || '').trim().replace(/^(CW-|CK-)/i, '')
      const targetShort = strip(target)
      return (list || []).find(item => {
        const no = String(item.space_no || item.parking_space || '').trim()
        return no === target || strip(no) === targetShort
      }) || null
    },
    syncSelectedParkingSpaceFromOptions(list) {
      const currentId = this.normalizeParkingSpaceId(this.form.parking_space_id)
      if (currentId !== null && currentId !== undefined && currentId !== '') {
        const foundById = (list || []).find(item => this.normalizeParkingSpaceId(item.id) === currentId)
        if (foundById) {
          this.selectedParkingSpace = this.normalizeParkingSpaceOption(foundById)
          this.ensureParkingSpaceOption(foundById)
          if (!this.form.parking_space) {
            this.form.parking_space = foundById.space_no || ''
          }
          return
        }
      }
      // 仅有车位文本、无 parking_space_id 时按车位号回显
      const foundByNo = this.matchParkingSpaceOptionBySpaceNo(list, this.form.parking_space)
      if (foundByNo) {
        const normalized = this.normalizeParkingSpaceOption(foundByNo)
        this.selectedParkingSpace = normalized
        this.ensureParkingSpaceOption(normalized)
        this.form.parking_space_id = normalized.id
        this.form.parking_space = normalized.space_no || this.form.parking_space
        return
      }
      if (this.selectedParkingSpace) {
        this.ensureParkingSpaceOption(this.selectedParkingSpace)
      }
    },
    lookupJwsPersonCode() {
      if (!this.useJwsApi || !this.form.community_id || !this.form.phone) return
      this.vehicleApi.findPersonCode({
        community_id: this.form.community_id,
        phone: this.form.phone,
        nuoche_phone: this.form.nuoche_phone || '',
        plate_no: this.form.plate || '',
        room_no: this.form.room_no || '',
        id: this.form.id || 0
      }).then(res => {
        if (res.code === 200 && res.result) {
          const code = res.result.person_code || res.result.renyuanbianma || ''
          this.form.person_code = code
          if (res.result.shuliang) {
            this.form.shuliang = Math.max(1, parseInt(res.result.shuliang, 10) || 1)
          }
        }
      }).catch(() => {})
    },
    applyHikExpireFromFee() {
      if (!this.isHikAddForm) return
      if (this.form.fee_expire_date) {
        this.form.hik_expire_date = this.form.fee_expire_date
        this.formOriginalHikExpireDate = this.form.hik_expire_date
        return
      }
      if (this.form.vehicle_type === '普通') {
        this.form.hik_expire_date = ''
        this.formOriginalHikExpireDate = ''
      }
    },
    loadParkingSpaces(communityId, keyword = '', roomNo = '') {
      if (!communityId) {
        this.parkingSpaceOptions = []
        this.parkingSpaceLoading = false
        return
      }
      this.parkingSpaceLoading = true
      const params = {
        community_id: communityId,
        limit: keyword || roomNo ? 50 : 500
      }
      if (keyword) params.keyword = keyword
      if (roomNo) params.room_no = roomNo
      this.vehicleApi.parkingSpaceSelect(params).then(res => {
        if (res.code === 200) {
          const list = this.normalizeParkingSpaceOptions(res.result || [])
          this.allParkingSpaceOptions = list
          this.parkingSpaceOptions = list
          this.syncSelectedParkingSpaceFromOptions(list)
          if (!list.length && !keyword) {
            this.$message.warning('该小区暂无车位数据，请先到「车位信息同步」页面同步')
          }
        } else {
          this.parkingSpaceOptions = []
          this.$message.error(res.message || '加载车位列表失败')
        }
      }).catch(() => {
        this.parkingSpaceOptions = []
        this.$message.error('加载车位列表失败')
      }).finally(() => {
        this.parkingSpaceLoading = false
      })
    },
    onParkingSpaceChange(parkingSpaceId) {
      if (!parkingSpaceId) {
        this.form.parking_space = ''
        this.selectedParkingSpace = null
        if (!this.form.room_no) {
          this.form.owner = ''
          this.form.phone = ''
        }
        if (!this.form.id) {
          this.form.id_card = ''
        }
        this.form.fee_expire_date = ''
        if (this.isHikAddForm) {
          this.applyHikExpireFromFee()
        }
        return
      }
      const space = this.parkingSpaceOptions.find(item => this.normalizeParkingSpaceId(item.id) === this.normalizeParkingSpaceId(parkingSpaceId))
      if (!space) return
      this.applyParkingSpaceBinding(space)
    },
    onCityChange() {
      if (this.filters.project && !this.projectSelectOptions.includes(this.filters.project)) {
        this.filters.project = ''
      }
    },
    resetFilters() {
      this.filters = defaultFilters()
      this.listQuery.page = 1
      if (this.useApi) {
        this.fetchList()
      } else {
        this.refreshMockPage()
      }
    },
    matchAbnormalFilter(row) {
      if (this.filters.abnormal === '__none__') return !row.abnormal
      if (this.filters.abnormal === '__has__') return !!row.abnormal
      if (this.filters.abnormal) return row.abnormal === this.filters.abnormal
      return true
    },
    filterList() {
      this.listQuery.page = 1
      if (this.useApi) {
        this.fetchList()
        return
      }
      this.refreshMockPage()
    },
    openForm(row) {
      this.drawerMode = 'edit'
      this.saveLoading = false
      if (row) {
        this.form = { ...defaultForm(), ...row, plate: row.plate, hik_expire_date: row.hik_expire_date || row.expire_date, person_code: row.person_code || '', shuliang: row.shuliang || 1 }
        this.form.parking_space_id = this.normalizeParkingSpaceId(this.form.parking_space_id)
        this.formOriginalHikExpireDate = this.form.hik_expire_date || ''
        this.extendAttachmentList = []
        if (row.vehicle_type === '延期') {
          this.form.attachment_url = ''
          this.form.attachment_name = ''
        } else if (row.vehicle_type === '特殊' && row.attachment_url) {
          this.form.attachment_url = row.attachment_url
          this.form.attachment_name = row.attachment_name || ''
        }
        this.selectedParkingSpace = this.buildParkingSpaceFromRow(row)
        if (this.selectedParkingSpace) {
          this.ensureParkingSpaceOption(this.selectedParkingSpace)
        }
        if (row.room_no) {
          this.ensureRoomOption(row.room_no, row.owner || '', row.phone || '')
        }
        if (this.useApi && row.community_id) {
          if (this.isBindEditForm) {
            this.loadRoomOptions(row.community_id, '')
            if (row.room_no) {
              this.loadParkingSpacesForRoom(row.community_id, row.room_no)
            } else {
              this.loadParkingSpaces(row.community_id)
            }
          } else {
            this.loadParkingSpaces(row.community_id)
          }
          if (this.useJwsApi) {
            this.lookupJwsPersonCode()
          }
        }
        this.formAttachmentList = row.attachment_name && row.vehicle_type === '特殊'
          ? [{ name: row.attachment_name, url: row.attachment_url || '' }]
          : []
      } else {
        this.form = defaultForm()
        this.formOriginalHikExpireDate = ''
        this.formAttachmentList = []
        this.extendAttachmentList = []
        this.parkingSpaceOptions = []
        this.roomOptions = []
        this.selectedParkingSpace = null
        const communityId = this.resolveFilterCommunityId()
        if (communityId) {
          this.form.community_id = communityId
          if (this.isHikAddForm || this.isJwsAddForm || this.isBindEditForm) {
            this.loadRoomOptions(communityId, '')
            this.loadParkingSpaces(communityId, '')
          } else {
            this.loadParkingSpaces(communityId)
          }
        }
      }
      this.detailRow = row || {}
      this.drawerVisible = true
    },
    showDetail(row) {
      this.drawerMode = 'detail'
      this.crossRecords = []
      if (this.useApi) {
        this.vehicleApi.detail({ id: row.id }).then(res => {
          if (res.code === 200) {
            this.detailRow = res.result
            this.loadCrossRecords(row.id)
          }
        })
      } else {
        this.detailRow = row
      }
      this.realtimeGarageResult = null
      this.queryingGarage = false
      this.syncingParkingFee = false
      this.drawerVisible = true
    },
    loadCrossRecords(id) {
      this.crossRecordsLoading = true
      this.vehicleApi.crossRecords({ id, page: 1, size: 20 }).then(res => {
        this.crossRecordsLoading = false
        if (res.code === 200) this.crossRecords = res.result.list || []
      }).catch(() => { this.crossRecordsLoading = false })
    },
    queryRealtimeGarage() {
      if (!this.detailRow.plate) return
      if (this.useApi) {
        this.queryingGarage = true
        this.vehicleApi.status({ id: this.detailRow.id }).then(res => {
          this.queryingGarage = false
          if (res.code === 200) {
            const status = res.result.in_garage || '否'
            this.realtimeGarageResult = { status, time: new Date().toLocaleString() }
            this.detailRow.in_garage = status
            this.$message.success(`${this.systemLabel}车场实时查询：当前${status === '是' ? '在库' : '不在库'}`)
          }
        }).catch(() => { this.queryingGarage = false })
        return
      }
      this.queryingGarage = true
      this.realtimeGarageResult = null
      setTimeout(() => {
        const records = accessRecords
          .filter(item => item.plate === this.detailRow.plate)
          .sort((a, b) => b.time.localeCompare(a.time))
        let status = '否'
        if (records.length) {
          status = records[0].direction === '入场' ? '是' : '否'
        } else {
          status = this.detailRow.in_garage === '是' ? '是' : '否'
        }
        const now = new Date()
        const pad = n => String(n).padStart(2, '0')
        const time = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
        this.realtimeGarageResult = { status, time }
        this.queryingGarage = false
        const sourceLabel = this.source === 'hik' ? '海康' : '捷卫士'
        this.$message.success(`${sourceLabel}车场实时查询：当前${status === '是' ? '在库' : '不在库'}（演示）`)
      }, 800)
    },
    syncParkingFee() {
      if (!this.canSyncParkingFee || !this.detailRow.id || !this.vehicleApi.syncParkingFee) return
      this.$confirm('将从天问同步该车位物业服务费，并按有效期更新车辆有效期，是否继续？', '同步物业费', {
        type: 'warning',
        confirmButtonText: '确定同步',
        cancelButtonText: '取消'
      }).then(() => {
        this.syncingParkingFee = true
        this.vehicleApi.syncParkingFee({ id: this.detailRow.id }).then(res => {
          this.syncingParkingFee = false
          if (res.code !== 200) {
            this.$message.error(res.message || res.msg || '同步失败')
            return
          }
          const result = res.result || {}
          if (result.vehicle) {
            this.detailRow = Object.assign({}, this.detailRow, result.vehicle)
          } else if (result.fee_expire_date) {
            this.detailRow.fee_expire_date = result.fee_expire_date
          }
          const listRow = (this.tableData || []).find(item => String(item.id) === String(this.detailRow.id))
          if (listRow && result.vehicle) {
            Object.assign(listRow, {
              fee_expire_date: result.vehicle.fee_expire_date,
              hik_expire_date: result.vehicle.hik_expire_date,
              abnormal: result.vehicle.abnormal
            })
          }
          if (result.remote_warning) {
            this.$message.warning(result.remote_warning)
          } else {
            const expire = result.fee_expire_date || (result.vehicle && result.vehicle.fee_expire_date) || '—'
            this.$message.success(`同步成功，车位费有效期：${expire}`)
          }
        }).catch(() => {
          this.syncingParkingFee = false
        })
      }).catch(() => {})
    },
    onVehicleTypeChange(type) {
      if (type === '普通') {
        if (this.isHikAddForm) {
          this.applyHikExpireFromFee()
        } else {
          this.form.hik_expire_date = this.formOriginalHikExpireDate
        }
        this.extendAttachmentList = []
      }
      if (type === '延期') {
        this.form.attachment_url = ''
        this.form.attachment_name = ''
        this.extendAttachmentList = []
      }
      if (type === '特殊') {
        this.form.room_no = ''
        this.form.parking_space_id = null
        this.form.parking_space = ''
        this.form.owner = ''
        this.form.phone = ''
        this.form.id_card = ''
        this.form.fee_expire_date = ''
        this.selectedParkingSpace = null
        this.parkingSpaceOptions = []
      }
      if (type !== '特殊') {
        if (type !== '延期') {
          this.form.attachment_name = ''
          this.form.attachment_url = ''
          this.formAttachmentList = []
        }
      }
    },
    onFormUploadSuccess(res, file) {
      if (res.code === 200 && res.result) {
        this.form.attachment_url = res.result.url || res.result
        this.form.attachment_name = file.name
      } else {
        this.$message.error(res.msg || res.message || '附件上传失败')
        this.formAttachmentList = []
      }
    },
    onFormUploadError() {
      this.$message.error('附件上传失败')
      this.form.attachment_url = ''
      this.form.attachment_name = ''
      this.formAttachmentList = []
    },
    onExtendAttachmentSuccess(res, file) {
      if (res.code === 200 && res.result) {
        const url = res.result.url || res.result
        this.form.attachment_url = url
        this.form.attachment_name = file.name
        this.extendAttachmentList = [{ name: file.name, url }]
      } else {
        this.$message.error(res.msg || res.message || '延期附件上传失败')
        this.form.attachment_url = ''
        this.form.attachment_name = ''
        this.extendAttachmentList = []
      }
    },
    onExtendAttachmentError() {
      this.$message.error('延期附件上传失败')
      this.form.attachment_url = ''
      this.form.attachment_name = ''
      this.extendAttachmentList = []
    },
    onExtendAttachmentRemove() {
      this.form.attachment_url = ''
      this.form.attachment_name = ''
      this.extendAttachmentList = []
    },
    getExtendAttachmentUrl() {
      if (this.form.attachment_url) return this.form.attachment_url
      const item = this.extendAttachmentList[0]
      return item && item.url ? item.url : ''
    },
    handleAttachmentChange(file, fileList) {
      this.formAttachmentList = fileList.slice(-1)
      this.form.attachment_name = file.name
    },
    handleAttachmentRemove() {
      this.form.attachment_name = ''
      this.formAttachmentList = []
    },
    saveForm() {
      if (this.saveLoading) return
      if (this.form.vehicle_type === '特殊' && !this.form.attachment_name && !this.form.attachment_url) {
        this.$message.warning('特殊车辆请上传审批流程截图或附件')
        return
      }
      if (this.useApi && this.form.id && this.form.vehicle_type === '延期') {
        if (!this.isExtendExpireChanged) {
          this.$message.warning('延期类型修改时必须调整有效期')
          return
        }
        if (!this.isExpireExtended) {
          this.$message.warning('延期修改时有效期必须晚于原有效期')
          return
        }
        if (!this.getExtendAttachmentUrl()) {
          this.$message.warning('延期修改有效期必须上传附件')
          return
        }
      }
      if (this.useApi && !this.form.id && this.form.vehicle_type === '延期' && this.form.hik_expire_date && !this.getExtendAttachmentUrl()) {
        this.$message.warning('新增延期车辆设置有效期必须上传附件')
        return
      }
      if (this.useApi) {
        if (!this.form.id && !this.form.community_id) {
          this.$message.warning('请选择小区')
          return
        }
        if (this.isHikAddForm && !this.isSpecialForm && !this.form.room_no) {
          this.$message.warning('请选择业主房号，或直接选择带房号的车位')
          return
        }
        if (this.isJwsAddForm && !this.isSpecialForm && !this.form.room_no) {
          this.$message.warning('请选择业主房号，或直接选择带房号的车位')
          return
        }
        const payload = {
          id: this.form.id,
          community_id: this.form.community_id,
          parking_space_id: this.isSpecialForm ? null : (this.form.parking_space_id || null),
          room_no: this.isSpecialForm ? '' : (this.form.room_no || ''),
          plate_no: this.form.plate,
          owner_name: this.isSpecialForm ? '' : this.form.owner,
          phone: this.isSpecialForm ? '' : this.form.phone,
          id_card: this.isSpecialForm ? '' : (this.form.id_card || ''),
          nuoche_phone: this.form.nuoche_phone,
          vehicle_type: this.form.vehicle_type,
          person_code: this.isSpecialForm ? '' : (this.form.person_code || ''),
          remark: this.form.remark || '',
          attachment_url: this.getExtendAttachmentUrl() || this.form.attachment_url || this.form.attachment_name
        }
        if (this.useJwsApi && !this.isSpecialForm) {
          payload.shuliang = Math.max(1, parseInt(this.form.shuliang, 10) || 1)
        }
        if (this.form.vehicle_type === '延期') {
          payload.hik_expire_date = this.form.hik_expire_date
          payload.jws_expire_date = this.form.hik_expire_date
        } else if (this.form.vehicle_type === '特殊') {
          payload.hik_expire_date = this.form.hik_expire_date
          payload.jws_expire_date = this.form.hik_expire_date
        } else if (this.useHikApi && this.form.hik_expire_date) {
          payload.hik_expire_date = this.form.hik_expire_date
        }
        const req = this.form.id ? this.vehicleApi.update(payload) : this.vehicleApi.add(payload)
        this.saveLoading = true
        req.then(res => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.drawerVisible = false
            this.fetchList()
          } else {
            this.$message.error(res.message || '保存失败')
          }
        }).catch(err => this.$message.error(err || '保存失败')).finally(() => {
          this.saveLoading = false
        })
        return
      }
      if (this.form.vehicle_type === '特殊' && !this.form.attachment_name) {
        this.$message.warning('特殊车辆请上传审批流程截图或附件')
        return
      }
      if (!this.form.id) {
        const newItem = {
          ...this.form,
          id: Date.now(),
          city: '衡水市',
          project: this.filters.project || this.projectSelectOptions[0],
          in_garage: '否',
          abnormal: '',
          renewal_logs: []
        }
        this.tableData.unshift(newItem)
        this.listQuery.page = 1
        this.refreshMockPage()
      } else {
        const index = this.tableData.findIndex(item => item.id === this.form.id)
        if (index > -1) {
          this.$set(this.tableData, index, { ...this.tableData[index], ...this.form })
          this.refreshMockPage()
        }
      }
      this.$message.success('演示数据已保存（未提交后端）')
      this.drawerVisible = false
    },
    handleRemove(row) {
      const garageHint = this.useHikApi
        ? '系统将校验出入库记录判断是否在库。'
        : this.useJwsApi
          ? '系统将查询捷卫士场内车判断是否在库，并同步注销月租车。'
          : '删除前系统将校验是否在车库（演示）。'
      const msg = `确认删除车辆 ${row.plate}？${garageHint}`
      this.$confirm(msg, '提示', { type: 'warning' })
        .then(() => {
          if (this.useApi) {
            this.vehicleApi.remove({ id: row.id }).then(res => {
              if (res.code === 200) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(res.message || '删除失败')
              }
            }).catch(err => this.$message.error(err || '删除失败'))
            return
          }
          this.tableData = this.tableData.filter(item => item.id !== row.id)
          this.refreshMockPage()
          this.$message.success('删除成功（演示）')
        }).catch(() => {})
    },
    handleExport() {
      if (this.useApi) {
        this.exportLoading = true
        this.vehicleApi.export(this.buildListParams()).then(res => {
          this.exportLoading = false
          if (res.code === 200 && res.result && res.result.url) {
            window.open(res.result.url, '_blank')
            this.$message.success('导出成功')
          } else {
            this.$message.error(res.message || '导出失败')
          }
        }).catch(() => { this.exportLoading = false })
        return
      }
      this.$message.success('导出 Excel（演示）')
    },
    showImportModal() {
      this.importCommunityId = this.resolveFilterCommunityId()
      this.importFileList = []
      this.importFileDefaultList = []
      this.importModalVisible = true
      this.$nextTick(() => {
        if (this.$refs.importUpload && this.$refs.importUpload.clearFileList) {
          this.$refs.importUpload.clearFileList()
        }
      })
    },
    resetImportModal() {
      this.importLoading = false
      this.importFileList = []
      this.importFileDefaultList = []
    },
    onImportFileUpdate(fileList) {
      this.importFileList = (fileList || []).map(item => item.path || item.url || '').filter(Boolean)
    },
    submitImport() {
      if (this.importLoading) return
      const communityId = this.importCommunityId || this.resolveFilterCommunityId()
      if (!communityId) {
        this.$message.warning('请选择小区')
        return
      }
      if (!this.importFileList.length) {
        this.$message.warning('请上传 Excel 文件')
        return
      }
      this.importLoading = true
      chechangJwsVehicle.importExcel({
        community_id: communityId,
        filepath: this.importFileList[0]
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(res.message || '导入成功')
          this.importModalVisible = false
          this.fetchList()
        } else {
          this.$message.error(res.message || '导入失败')
        }
      }).catch(err => {
        this.$message.error(err || '导入失败')
      }).finally(() => {
        this.importLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/page.scss';

.upload-tip {
  margin: 8px 0 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

.rent-extra-tip {
  margin-left: 8px;
  color: #e6a23c;
}

.in-garage-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.in-garage-query-btn {
  margin-left: 4px;
}

.realtime-garage-tip {
  margin-top: -4px;
  padding-left: 0;
  font-size: 13px;
  color: #606266;
}

.realtime-garage-tip .query-time {
  margin-left: 6px;
  color: #909399;
  font-size: 12px;
}

.vehicle-detail {
  color: #303133;
}

.vd-hero {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 16px;
  margin-bottom: 18px;
  padding: 18px 20px;
  border-radius: 10px;
  background:
    linear-gradient(135deg, rgba(16, 103, 224, 0.12) 0%, rgba(16, 103, 224, 0.03) 48%, #f7fafc 100%),
    linear-gradient(180deg, #ffffff 0%, #f5f8fc 100%);
  border: 1px solid #d9e6f8;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.vd-hero-main {
  min-width: 0;
  flex: 1;
}

.vd-plate {
  font-size: 28px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: 1px;
  color: #123a73;
  font-family: "DIN Alternate", "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
}

.vd-hero-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.vd-hero-side {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  min-width: 168px;
  padding-left: 16px;
  border-left: 1px solid rgba(16, 103, 224, 0.18);
}

.vd-hero-owner {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.vd-hero-label {
  font-size: 12px;
  color: #8090a8;
}

.vd-hero-value {
  font-size: 14px;
  font-weight: 600;
  color: #243247;
  word-break: break-all;
}

.vd-section {
  margin-bottom: 18px;
  padding: 14px 16px 12px;
  background: #fff;
  border: 1px solid #e8eef6;
  border-radius: 8px;
}

.vd-section-last {
  margin-bottom: 0;
}

.vd-section-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #1f2d3d;
}

.vd-section-bar {
  width: 3px;
  height: 14px;
  border-radius: 2px;
  background: #1067e0;
}

.vd-section-count {
  margin-left: auto;
  min-width: 22px;
  padding: 0 7px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: #1067e0;
  background: #eaf2ff;
  border-radius: 10px;
}

.vd-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
}

.vd-cell {
  min-width: 0;
  padding: 10px 12px;
  background: #f7f9fc;
  border-radius: 6px;
  border: 1px solid #eef2f7;
}

.vd-cell-wide,
.vd-cell-action {
  grid-column: 1 / -1;
}

.vd-lab {
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
  color: #8a97a8;
  line-height: 1.4;
}

.vd-val {
  display: block;
  font-size: 14px;
  color: #303133;
  line-height: 1.5;
  word-break: break-all;
}

.vd-val-row,
.vd-expire-value-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.vd-realtime-tip {
  margin: 8px 0 0;
  font-size: 12px;
  color: #606266;
}

.vd-query-time {
  margin-left: 6px;
  color: #909399;
}

.vd-expire-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.vd-expire-card {
  padding: 14px 16px;
  border-radius: 8px;
  background: linear-gradient(180deg, #f3f7ff 0%, #fbfcff 100%);
  border: 1px solid #dce8f8;
}

.vd-expire-label {
  font-size: 12px;
  color: #7b8ba1;
  margin-bottom: 8px;
}

.vd-expire-value {
  font-size: 20px;
  font-weight: 700;
  color: #1067e0;
  letter-spacing: 0.3px;
  font-family: "DIN Alternate", "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
}

.vd-table {
  border-radius: 6px;
  overflow: hidden;
}

.vd-table ::v-deep .el-table__header th {
  background: #f5f8fc;
  color: #5a6a7e;
  font-weight: 600;
}

@media (max-width: 768px) {
  .vd-hero {
    flex-direction: column;
  }

  .vd-hero-side {
    min-width: 0;
    padding-left: 0;
    padding-top: 12px;
    border-left: none;
    border-top: 1px solid rgba(16, 103, 224, 0.18);
  }

  .vd-grid,
  .vd-expire-grid {
    grid-template-columns: 1fr;
  }
}

.parking-space-text {
  white-space: normal;
  word-break: break-all;
  line-height: 1.4;
}

::v-deep .parking-space-cell .cell {
  white-space: normal !important;
}

.abnormal-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  max-width: 100%;
  overflow: hidden;
}

.abnormal-item {
  display: inline-block;
  max-width: 100%;
  box-sizing: border-box;
  padding: 0 6px;
  font-size: 12px;
  line-height: 20px;
  color: #f56c6c;
  background: #fef0f0;
  border: 1px solid #fbc4c4;
  border-radius: 2px;
  white-space: normal;
  word-break: break-all;
}

::v-deep .abnormal-cell .cell {
  white-space: normal !important;
  overflow: hidden;
}
</style>

<style lang="scss">
@import '../styles/panel.scss';
</style>
